/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const orgAccountSummary = {
  header: 'Resumos de contas interrompidos ({{count}})',
  name: 'Unidade',
  details: {
    header: 'Detalhes do resumo da conta',
    uid: 'Unidade ID',
    name: 'Cliente',
    address: 'Endereço',
    creditRep: 'Representante de Crédito',
    creditLine: 'Linha de Crédito',
    currentBalance: 'Saldo atual',
    openBalance: 'Saldo aberto',
    pastDueBalance: 'Saldo vencido',
    dayRange: '{{{minBoundary}}-{{{maxBoundary}} Dias',
    dayPlus: '{{{minBoundary}}+ Dias',
    notApplicable: 'n/a',
  },
  document: {
    header: 'Documentos',
    id: 'Número do documento',
    type: 'Tipo de documento',
    date: 'Criado em',
    dueDate: 'Expiração em',
    originalAmount: 'Monto original',
    openAmount: 'Quantidade em aberto',
    status: 'Estado',
    attachment: 'Anexo',
    download: 'Baixar',
    attachmentDescription: 'Baixar attachment for {{{type}} {{{{id}}.',
    noneFound: 'Nenhum documento encontrado',
  },
  sorts: {
    byCreatedAtDateAsc: 'Criado em Ascending',
    byCreatedAtDateDesc: 'Criado em Descending',
    byDueAtDateAsc: 'Expiração em Ascending',
    byDueAtDateDesc: 'Expiração em Descending',
    byOriginalAmountAsc: 'Monto original Ascendente',
    byOriginalAmountDesc: 'Monto original Descendente',
    byAbrirAmountAsc: 'Quantidade em aberto Ascending',
    byAbrirAmountDesc: 'Quantidade em aberto Descending',
    byOrgDocumentTypeAsc: 'Tipo de documento Crescente',
    byOrgDocumentTypeDesc: 'Tipo de documento Decrescente',
    byEstadoAsc: 'Estado Ascendente',
    byEstadoDesc: 'Estado Descendente',
    byOrgDocumentIdAsc: 'Número do documento Ascending',
    byOrgDocumentIdDesc: 'Número do documento Descending',
  },
  statuses: {
    open: 'Abrir',
    closed: 'Fechado',
    all: 'Durantedo',
  },
  filterByOptions: {
    orgDocumentId: 'Número do documento',
    orgDocumentIdRange: 'Número do documento Range',
    orgDocumentType: 'Tipo de documento',
    createdAtDateRange: 'Criado em Range',
    dueAtDateRange: 'Expiração em Range',
    amountRange: 'Gama Monto original',
    openAmountRange: 'Quantidade em aberto Range',
  },
  sortBy: 'Classificar por',
  sortDocumentos: 'Classificar documentos',
  filter: {
    status: 'Estado',
    filterBy: 'Filtrar por',
    documentNumber: 'Número do documento',
    documentType: 'Tipo de documento',
    startRange: 'De',
    endRange: 'Durante',
    clear: 'Limpar Durantedo',
    search: 'Achar',
    errors: {
      toDateMustComeAfterDe:
        "Escolha uma data de término após a data de início.",
      toAmountMustBeLargeThanDe:
        "Escolha um valor de intervalo final menor que o valor inicial.",
    },
  },
  hint: 'Os resumos de contas permitem que você revise informações gerais sobre uma unidade, incluindo saldos e o resumo de vencimento das faturas. Aqui, também é possível navegar por uma lista de documentos de transação para uma unidade.',
};

export const orgAccountSummaryList = {
  breadcrumbs: {
    list: 'Resumos de contas',
    details: '{{{name}}',
  },
};

export const accountSummary = {
  orgAccountSummary,
  orgAccountSummaryList,
};
